interface SaveFileType {
  name?: string;
  url?: string;
}

/**
 * Creates a download link and triggers a download.
 * For local URLs (blob:, data:), this works directly.
 * For remote URLs (http/https), consider using downloadFromUrl instead.
 */
export const saveFile = ({ url, name }: SaveFileType): void => {
  if (!url) return;
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name || 'download');
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
};

/**
 * Downloads a file from a URL using native browser download.
 * Works with S3 presigned URLs - browser handles the download directly
 * without loading the file into memory first.
 */
export const downloadFromUrl = async ({ url, name }: SaveFileType): Promise<void> => {
  if (!url) {
    throw new Error('No URL provided for download');
  }
  // Satisfy eslint require-await while maintaining async signature for backward compatibility
  await Promise.resolve();
  saveFile({ url, name });
};
